<template>
  <div>
    <v-checkbox
      v-if="type === 'multiSelection'"
      :label="answer"
      :value="data.id"
      hide-details
      v-model="value"
    />
    <v-radio
      v-else-if="type === 'singleSelection'"
      :label="answer"
      :value="data.id"
    />
  </div>
</template>

<script>
  import {
    mapState
  } from 'vuex'
  import utils from '@/services/utils'
  export default {
   props: {
      type: {
        type: String,
        required: true
      },
      data: {
        type: Object,
        required: true,
      },
      value: {
        type: Array,
        required: null
      }
    },
    data () {
      return {
        answer: null
      }
    },
    computed: {
      ...mapState('app',['locale']),
    },
    watch: {
      locale () {
        this.prepareData()
      },
      'data.answer' () {
        this.prepareData()
      },
    },
    mounted () {
      this.prepareData()
    },
    methods: {
      prepareData () {
        this.answer = utils.getTranslation(this.data.answer, this.locale)
      }
    }
  }
</script>